import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useI18n } from "../i18n";
import { useAuth } from "../AuthContext";
import { saveProfile } from "../profileStore";
import api from "../api";

const Login = () => {
  const { t } = useI18n();
  const { setAccessCode, setServiceMode } = useAuth();
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await api.post("/auth/verify-code", { code });
      if (res.data.ok) {
        setAccessCode(code.trim().toUpperCase());
        setServiceMode(!!res.data.service_mode);
        // Server-side restore: if a profile was previously consumed on this
        // code, auto-restore it so F5 / cookie wipe can't reset the lock.
        // Service code (!iulserv@) always starts fresh — owner testing.
        if (res.data.last_profile && !res.data.service_mode) {
          saveProfile(res.data.last_profile);
          navigate("/app", { replace: true });
        } else {
          navigate("/onboarding", { replace: true });
        }
      }
    } catch (err) {
      setError(t.login.invalid);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-4 md:px-8 py-20">
      <div className="font-mono text-xs tracking-widest text-[#FF3B30] mb-3">// AUTH</div>
      <h1 className="font-heading text-5xl mb-2">{t.login.title}</h1>
      <p className="text-white/70 mb-8">{t.login.subtitle}</p>
      <form onSubmit={handleSubmit}>
        <label className="sne-label" htmlFor="code-input">{t.login.code_label}</label>
        <input
          id="code-input"
          data-testid="login-code-input"
          className="sne-input font-mono text-lg uppercase tracking-widest"
          placeholder={t.login.code_placeholder}
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
        />
        {error && <div className="mt-3 text-[#FF3B30] font-mono text-xs" data-testid="login-error">{error}</div>}
        <button
          data-testid="login-submit-btn"
          type="submit"
          disabled={loading || !code}
          className="btn-primary w-full mt-6"
        >
          {loading ? t.common.loading : `${t.login.submit} →`}
        </button>
      </form>
      <div className="mt-6 font-mono text-xs">
        <Link to="/pricing" data-testid="login-no-code" className="text-white/60 hover:text-white">
          {t.login.no_code} →
        </Link>
      </div>
    </div>
  );
};

export default Login;
